import CurrentUser from 'auth/CurrentUser';
import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

type UserStore = {
  isSignedIn: () => boolean;
};

type Options = {
  location: string;
  userStore?: UserStore;
};

type onEnterHandler = (
  state: RouterState,
  replace: (location: LocationDescriptor) => void,
  callback: Function
) => void;

type Handler = (options: Options) => onEnterHandler;

const RequireUnauth: Handler = (opts: Options) => (state, replace, callback) => {
  const options = { userStore: CurrentUser, ...opts };

  if (options.userStore.isSignedIn()) {
    replace(options.location);
  }

  callback();
};

export default RequireUnauth;
